/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Proof_TitleInputs */

const en_cap_proof_title = /** @type {(inputs: Cap_Proof_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Systems we run ourselves`)
};

const lv_cap_proof_title = /** @type {(inputs: Cap_Proof_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sistēmas, ko darbinām paši`)
};

/**
* | output |
* | --- |
* | "Systems we run ourselves" |
*
* @param {Cap_Proof_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_proof_title = /** @type {((inputs?: Cap_Proof_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Proof_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_proof_title(inputs)
	return en_cap_proof_title(inputs)
});